module.exports = __webpack_public_path__ + "static/media/ty_dummies_ppt.5bc86455.jpeg";